import {useSelector} from "react-redux";

import {CopyrightFooter, CopyrightInfo, CopyrightLink} from "./styles";

import {AppState, select} from "../../store";

export const Copyright = () => {
  const user = useSelector((state: AppState) =>
    select.adminSession.user(state),
  );
  const currentYear = new Date().getFullYear();

  return (
    <CopyrightFooter>
      <CopyrightInfo>
        Reside
        <CopyrightLink href="https://www.linkedin.com/company/reside-admissions">
          {" "}
          💙{" "}
        </CopyrightLink>
        {user?.firstName ?? ""} - ©{currentYear}
        <CopyrightLink href="https://resideadmissions.com">
          {" "}
          Reside Admission Inc.
        </CopyrightLink>
      </CopyrightInfo>
    </CopyrightFooter>
  );
};
